import React from 'react';
import { useLanguage } from '../../Contexts/LanguageContext';
import './TaskList.scss';

const TaskList = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const taskHeading = data.purposeSection.taskHeading;
  const taskList= data.purposeSection.tasks;

  return (
    <>      
      <div className="task-container">
          <h3>{taskHeading}</h3>
          <div className="custom-card">
            <ol>
              {taskList.map((task, index) => (
                <li key={index}>{task}</li>
              ))}              
            </ol>
          </div>
        </div>
    </>
  );
};

export default TaskList;
